<template>
  <div class="all_part" id="main">
    <div>
      <titleBlock_computer></titleBlock_computer>
    </div>
    <div class="input_button">
      <div class="all_input">
        <div class="all_input_top">
          <div>
            <div class="input_arr">
              <div class="input_styles">
                <div>
                  <el-input
                    v-model="newItemNo"
                    placeholder="新旧料号 | 询价单号"
                    style="width: 460px"
                  ></el-input>
                </div>
                <div class="submit_button">
                  <div class="search_button">
                    <div class="sousuoButton">
                      <el-button
                        type="primary"
                        @click="serchChanPin"
                        style="
                          height: 48px;
                          width: 144px;
                          margin-left: 20px;
                          font-size: 16px;
                        "
                        >搜索
                      </el-button>
                      <div class="icon_sou">
                        <img src="../assets/SouSuo.png" alt="" width="14px" />
                      </div>
                    </div>
                  </div>
                  <div class="all_second_button">
                    <div class="ChongZhi">
                      <div class="second_button" @click="clearInput">
                        <el-button
                          plain
                          type="primary"
                          style="width: 92px; height: 48px; font-size: 16px"
                          >重置
                        </el-button>
                      </div>
                      <div class="icon_chong">
                        <img src="../assets/ChongZhi.png" alt="" width="14px" />
                      </div>
                    </div>
                    <div class="second_button">
                      <div class="ShouQi">
                        <div>
                          <el-button
                            plain
                            type="primary"
                            style="width: 92px; height: 48px; font-size: 16px"
                            @click="inputShow"
                          >
                            {{ PanDuanShou ? "展开" : "收起" }}
                          </el-button>
                        </div>
                        <div :class="PanDuanShou ? 'icon_Shou' : 'icon_Shous'">
                          <img src="../assets/ShouQI.png" alt="" width="14px" />
                        </div>
                      </div>
                    </div>

                    <div class="second_button" @click="clearInput">
                      <div class="Fanhu">
                        <div>
                          <el-button
                            plain
                            type="primary"
                            style="width: 92px; height: 48px"
                            @click="back_menu"
                            >返回
                          </el-button>
                        </div>
                        <div class="icon_fan">
                          <img src="../assets/FanHui.png" alt="" width="14px" />
                        </div>
                      </div>
                    </div>
                    <div class="second_button">
                      <div>
                        <el-button
                          @click="serchGouWuChe"
                          plain
                          type="primary"
                          style="width: 122px; height: 48px; font-size: 16px"
                          >查看清单
                        </el-button>
                      </div>
                    </div>
                    <div class="second_button">
                      <div>
                        <el-button
                          @click="download"
                          plain
                          type="primary"
                          style="width: 122px; height: 48px; font-size: 16px"
                          >导出清单
                        </el-button>
                      </div>
                    </div>
                    <div class="second_button">
                      <div>
                        <el-button
                          @click="clearall"
                          plain
                          type="primary"
                          style="width: 122px; height: 48px; font-size: 16px"
                          >清空清单
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!PanDuanShou">
              <div class="input_arr">
                <div class="input_style">
                  <el-select
                    v-model="ChanPinDaLei_choice"
                    placeholder="产品类别"
                    style="width: 150px"
                    @change="change('a', ChanPinDaLei_choice)"
                  >
                    <el-option
                      v-for="item in ChanPinDaLei_Select"
                      :key="item.value"
                      :label="item.category_big"
                      :value="item.category_big"
                      @click="this.serchChanPinXiaoLei()"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="input_style">
                  <el-select
                    v-model="ChanPinXiaoLei_choice"
                    placeholder="产品小类"
                    style="width: 150px"
                    @change="change('b', ChanPinXiaoLei_choice)"
                  >
                    <el-option
                      v-for="item in ChanPinXiaoLei_Select"
                      :key="item.value"
                      :label="item.category_small"
                      :value="item.category_small"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="input_style">
                  <el-input
                    v-model="internal_meridian"
                    placeholder="内径"
                    style="width: 150px"
                  ></el-input>
                </div>
                <div class="input_style">
                  <el-input
                    v-model="wire_diameter"
                    placeholder="线径"
                    style="width: 150px"
                  ></el-input>
                </div>
              </div>

              <div class="input_arr">
                <div class="input_style">
                  <el-select
                    @change="change('b', CaiZhi_choice)"
                    v-model="CaiZhi_choice"
                    placeholder="材质"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in CaiZhi_select"
                      :key="item.value"
                      :label="item.material"
                      :value="item.material"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="input_style">
                  <el-select
                    v-model="YanSe_Choice"
                    placeholder="颜色"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in YanSe_Select"
                      :key="item.value"
                      :label="item.color"
                      :value="item.color"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="input_style">
                  <el-select
                    v-model="YingDu_Choice"
                    placeholder="硬度"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in YingDu_Select"
                      :key="item.value"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="input_style">
                  <el-select
                    filterable
                    v-model="CaiLiaoXinXi_Code_Choice"
                    placeholder="材料信息代码"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in CaiLiaoXinXi_Code_Select"
                      :key="item.value"
                      :label="item.material_code"
                      :value="item.material_code"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="input_style">
                  <el-select
                    filterable
                    v-model="BiaoZhun_Choice"
                    placeholder="尺寸标准代码"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in BiaoZhun_Select"
                      :key="item.value"
                      :label="item.standard_code"
                      :value="item.standard_code"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="input_style">
                  <el-input
                    v-model="oldMaterialNo"
                    placeholder="新旧料号|询价单号 多个查询空格隔开"
                    style="width: 250px"
                  ></el-input>
                </div>



              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="PanDuanShou == false ? 'table' : 'tables'">
      <!-- 新增 :row-class-name 行样式绑定 -->
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        height="45%"
        border
        row-key="id"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        :tree-props="{ hasChildren: 'hasChildren', children: 'child' }"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="index" width="120" label="操作" fixed>
          <template slot-scope="scope">
            <el-button
              @click="TianJiaTest(scope.row)"
              v-show="scope.row.child || scope.row.child == []"
              v-if="PanDuanZhuangTai == 1"
            >
              添加
            </el-button>
            <el-button
              @click="deletess(scope.row)"
              v-show="scope.row.child || scope.row.child == []"
              v-if="PanDuanZhuangTai == 2"
            >
              删除
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          fixed
          prop="oldMaterialNo"
          label="旧料号"
          width="160"
        ></el-table-column>
        <el-table-column
          fixed
          prop="newItemNo"
          label="新料号"
          width="160"
        ></el-table-column>
        <el-table-column
          fixed
          sortable
          prop="shanghai_stock"
          label="可用数量"
          width="150"
        ></el-table-column>
        <el-table-column
          fixed
          prop="taiwan_stock"
          label="实际在库数量"
          width="150"
        ></el-table-column>

        <el-table-column
          fixed
          prop="quantity_zhongshan"
          label="中山厂库存"
          width="120"
        ></el-table-column>
        <el-table-column
          fixed
          prop="quantity_taiwan"
          label="台湾厂库存"
          width="120"
        ></el-table-column>
        <el-table-column
          fixed
          prop="quantity_thailand"
          label="滞销品库存"
          width="120"
        ></el-table-column>

        <el-table-column
          fixed
          prop="transport"
          label="在途总量"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="material_number"
          label="材料信息代码"
          width="180"
        ></el-table-column>

        <el-table-column
          prop="internal_meridian"
          label="内径"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="wire_diameter"
          label="线径/宽度"
          width="120"
        ></el-table-column>
        <el-table-column prop="MOQ" label="MOQ" width="120"></el-table-column>
        <el-table-column
          prop="packing_quantity"
          label="包装量"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="money"
          label="面价"
          v-if="user_leave.standardTypePrice == 1"
          width="160"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="suggested_price"
          label="分包价"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="executive_director"
          label="工程师"
          width="160"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="sales_manager"
          label="主管/客户经理"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="industry_manager"
          label="部门经理"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="project_price"
          label="专案价格"
          width="140"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="mould_cost"
          label="成品模具费/样品模具费"
          width="120"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="other_expenses"
          label="其他费用"
          width="120"
        ></el-table-column>

        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="remarks"
          label="其他说明"
          width="120"
        ></el-table-column>

        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="production_cycle"
          label="生产周期"
          width="120"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="inquiry_no"
          label="询价单号"
          width="120"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="platform_number"
          label="平台编号"
          width="120"
        ></el-table-column>
        <el-table-column
          v-if="user_leave.standardTypePrice == 1"
          prop="quotation_no"
          label="供应商报价单号"
          width="120"
        ></el-table-column>

        <el-table-column
          prop="shanghai_stock"
          label="上海库存"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="taiwan_stock"
          label="台湾库存"
          width="120"
        ></el-table-column>

        <el-table-column
          prop="standard_code"
          label="尺寸标准代码"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="standard"
          label="标准"
          width="120"
        ></el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        layout="prev, pager, next"
        :total="tableData.total"
        hide-on-single-page="true"
        @current-change="reflash"
      >
      </el-pagination>
    </div>
    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>

<script>
import titleBlock_computer from "../views/titleBlock_computer.vue";
import { httpUrl } from "../components/publics";
import DevicePixelRatio from '@/views/DevicePixelRatio.js';
export default {
  data() {
    return {
      user_leave: {},
      PanDuanShou: false,
      tableData: [],
      newItemNo: "", //新料号
      oldMaterialNo: "", //旧料号
      internal_meridian: "", // 产品内径
      wire_diameter: "", //产品线径
      ChanPinXiaoLei_choice: "", //产品小类选择
      CaiZhi_choice: "", //材质选择   //material
      BiaoZhun_Choice: "", //标准选择
      YingDu_Choice: "", //硬度选择
      standard_code: "", //标准代码
      inquiry_no: "", //询价单号
      CaiLiaoXinXi_Code_Choice: "", //材料信息选择
      ChanPinDaLei_choice: "", // 产品大类选择
      YanSe_Choice: "", //颜色选择
      ChanPinDaLei_Select: [], // 产品大类下拉框
      ChanPinXiaoLei_Select: [], //产品小类下拉框
      CaiZhi_select: [], //材质选择拉下
      BiaoZhun_Select: [], //标准下拉框
      YingDu_Select: [], //硬度下拉框
      CaiLiaoXinXi_Code_Select: [], //材料信息下拉框
      YanSe_Select: [], //颜色下拉框
      page: "",
      multipleSelection: [],
      PanDuanZhuangTai: "",
    };
  },
  watch: {
    ChanPinDaLei_choice(newName, oldName) {
      this.serchChanPinXiaoLei(newName);
    },
    CaiZhi_choice(newName, oldName) {
      this.serchCaiLiaoXinxi(newName);
      this.serchYanSe(newName);
      this.serchBiaoZhun(newName);
    },
  },
  mounted() {
    this.serchCaiZhi();
    this.serchChanPinDaLei();
    new DevicePixelRatio().init();
    this.serchYingDu();
    this.getUser();
  },

  methods: {
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave, "这里看的是userID");
    },
    add(val) {
      this.axios
        .post(
          httpUrl + "/api/index/offerAdd",
          this.$qs.stringify({
            data: val,
          })
        )
        .then((response) => {
          if (response.data.code === 200) {
            this.$message(response.data.message);
            console.log("success", response.data);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    delete(val) {
      this.axios
        .get(httpUrl + `/api/index/offerStrDel?id=${val}`)
        .then((response) => {
          if (response.data.code === 200) {
            this.serchGouWuChe2();
            this.$message(response.data.message);
            console.log("success", response.data);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    TianJiaTest(vals) {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      let arr = [];
      arr.push(vals)
      arr.forEach((element) => {
        element.user_id = selectID;
      });
      let a = {};
      arr.map((val) => {
        delete val.child;
        a = JSON.stringify(val);
      });
      this.add(a);
      console.log(a);
      console.log(this.$refs.multipleTable.selection);
    },
    deletess(valsa) {
      let stringTest = this.$refs.multipleTable.tableData;
      stringTest.forEach((element) => {
        // element.user_id = selectID;
      });
      let a = {};
      console.log(valsa.id)
      this.delete(valsa.id);
      console.log(stringTest);
      console.log(a);
      console.log(this.$refs.multipleTable.selection);
    },

    change(params, val) {
      console.log(params);
      if (params == "a" && val != "") {
        this.ChanPinXiaoLei_choice = "";
        this.CaiZhi_choice = "";
      }
    },
    back_menu() {
      this.$router.push("/second_menuComputer_PriceAndInventory");
    },
    clearall() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.axios
        .get(httpUrl + `/api/index/offerDel?user_id=${selectID}`)
        .then((response) => {
          if (response.data.code === 200) {
            this.serchGouWuChe2();
            this.$message(response.data.message);
            console.log("success", response.data);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    clearInput() {
      this.tableData = [];
      this.newItemNo = ""; //新料号
      this.oldMaterialNo = ""; //旧料号
      this.internal_meridian = ""; // 产品内径
      this.wire_diameter = ""; //产品线径
      this.ChanPinXiaoLei_choice = ""; //产品小类选择
      this.CaiZhi_choice = ""; //材质选择   //material
      this.BiaoZhun_Choice = ""; //标准选择
      this.YingDu_Choice = ""; //硬度选择
      this.standard_code = ""; //标准代码
      this.inquiry_no = ""; //询价单号
      this.CaiLiaoXinXi_Code_Choice = ""; //材料信息选择
      this.ChanPinDaLei_choice = ""; // 产品大类选择
      this.YanSe_Choice = ""; //颜色选择
      this.YanSe_Select = [];
      this.ChanPinDaLei_Select = [];
      this.serchCaiZhi();
      this.serchChanPinDaLei();
      this.serchYingDu();
    },
    inputShow() {
      this.PanDuanShou = !this.PanDuanShou;
    },
    reflash(val) {
      this.page = val;
      this.serchFinanceinfo();
    },
    serchBiaoZhun(val) {
      this.axios
        .get(httpUrl + `/api/index/standard?material=${val}`)
        .then((response) => {
          if (response.data.code == 200) {
            this.BiaoZhun_Select = response.data.data;
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchYingDu() {
      this.axios
        .get(httpUrl + `/api/index/hardness`)
        .then((response) => {
          if (response.data.code == 200) {
            this.YingDu_Select = response.data.data;
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchCaiLiaoXinxi(vars) {
      this.axios
        .get(httpUrl + `/api/index/material_number?material=${vars}`)
        .then((response) => {
          if (response.data.code == 200) {
            this.CaiLiaoXinXi_Code_Select = response.data.data;
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchYanSe(vals) {
      this.axios
        .get(httpUrl + `/api/index/colorOffer?material=${vals}`)
        .then((response) => {
          if (response.data.code == 200) {
            this.YanSe_Select = response.data.data;
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchCaiZhi() {
      this.axios
        .get(
          httpUrl +
            `/api/index/standard_material?category_small=${this.ChanPinXiaoLei_choice}&`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.CaiZhi_select = response.data.data;
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinXiaoLei(val) {
      this.axios
        .get(
          httpUrl + `/api/index/standard_category?category_big=${val}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinXiaoLei_Select = response.data.data;
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinDaLei() {
      this.axios
        .get(httpUrl + `/api/index/category`)
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinDaLei_Select = response.data.data;
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPin() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.axios
        .get(
          httpUrl +
            `/api/index/offer?newItemNo=${this.newItemNo}&oldMaterialNo=${this.oldMaterialNo}&material=${this.CaiZhi_choice}&hardness=${this.YingDu_Choice}&color=${this.YanSe_Choice}&standard_code=${this.BiaoZhun_Choice}&material_number=${this.CaiLiaoXinXi_Code_Choice}&internal_meridian=${this.internal_meridian}&wire_diameter=${this.wire_diameter}&&inquiry_no=${this.inquiry_no}&oldMaterialNo=${this.oldMaterialNo}&category_big=${this.ChanPinDaLei_choice}&category_small=${this.ChanPinXiaoLei_choice}&page=${this.page}&user_id=${selectID}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.PanDuanZhuangTai = 1;
            if (response.data.code == 401) {
              this.$message(response.data.message);
            } else {
              response.data.data.map((value, key) => {
                if (value.child.length > 0) {
                  value.child.map((val, num) => {
                    val["id"] = value.id * 10 + num;
                  });
                }
              });
              this.tableData = response.data.data;
            }
            this.$message(response.data.message);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    serchGouWuChe2() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.axios
        .get(
          httpUrl +
            `/api/index/offerList?page=${this.page}&user_id=${selectID}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.PanDuanZhuangTai = 2;
            if (response.data.data.length > 100) {
            } else {
              response.data.data.map((value, key) => {
                if (value.child.length > 0) {
                  value.child.map((val, num) => {
                    val["id"] = value.id * 10 + num;
                  });
                }
              });
              this.tableData = response.data.data;
            }
          } else if (response.data.code == 401) {
            this.tableData = [];
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    serchGouWuChe() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.axios
        .get(httpUrl + `/api/index/offerList?user_id=${selectID}`)
        .then((response) => {
          if (response.data.code == 200) {
            this.PanDuanZhuangTai = 2;
            if (response.data.data.length > 100) {
              this.$message(response.data.message);
            } else {
              response.data.data.map((value, key) => {
                if (value.child.length > 0) {
                  value.child.map((val, num) => {
                    val["id"] = value.id * 10 + num;
                  });
                }
              });
              this.tableData = response.data.data;
            }
            this.$message(response.data.message);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    download() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.axios
        .get(httpUrl + `/api/index/offerList?user_id=${selectID}`)
        .then((response) => {
          if (response.data.code == 200) {
            window.location.href =
              httpUrl +
              `/api/index/excelUpdateOffer?user_id=${selectID}`;
          }
          this.$message(response.data.message);
        })
        .catch((error) => console.log(error, "error"));
    },
    TianJiaZhanShi() {
      this.axios
        .POST(httpUrl + `/api/index/offerAdd?`, {
          offer_id: this.PanDuanShou,
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinXiaoLei_Select = response.data.data;
          }
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    pan_Zreo(row) {
      console.log('这里面是来测试我这个方法是否使用')
      if (row.taiwan_stock == null) {
        return 0
      } else {
        return row.taiwan_stock
      }
    },
    // 新增：判断行是否停售，返回自定义样式类
    tableRowClassName({ row }) {
      if (row.suggested_price === '停售') {
        return 'row-stop-sale';
      }
      return '';
    }
  },
  components: {
    titleBlock_computer,
  },
};
</script>

<style>
.table-column-hidden .el-checkbox__input {
  display: none;
}

.el-input {
  border: 1px solid #b7b7b7;
  border-radius: 4px;
  color: #353535;
}
</style>

<style scoped>
.el-icon-my-SouSuo {
  background: url("../assets/SouSuo.png") no-repeat;
  font-size: 16px;
  background-size: cover;
}

.el-icon-my-SouSuo:before {
  content: "";
  font-size: 16px;
}

.all_part {
  min-height: 925px;
  min-width: 1920px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;
}

.all_input_bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-right: 20px;
}

.second_button {
  margin-left: 20px;
}

.Copyright_information {
  margin-top: auto;
  margin-bottom: 10px;
}

.table {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  height: 66%;
  width: 100%;
}

.tables {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  height: 80%;
}

.input_style {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 10px;
}

.input_styles {
  width: 55%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.input_arr {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.input_arr_span {
  margin-right: 10px;
  font-size: 14px;
}

.sousuoButton {
  position: relative;
}

.icon_sou {
  top: 16px;
  left: 40px;
  position: absolute;
}

.ChongZhi {
  position: relative;
}

.icon_chong {
  top: 16px;
  left: 32px;
  position: absolute;
}

.ShouQi {
  position: relative;
}

.icon_Shou {
  top: 14px;
  left: 12px;
  transform: rotate(180deg);
  position: absolute;
}

.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
}

.icon_fan {
  top: 16px;
  left: 12px;
  position: absolute;
}

.Fanhu {
  position: relative;
}

/* 分包价=停售 整行红色样式 */
/deep/ .row-stop-sale {
  background-color: #fef0f0 !important;
}
/deep/ .row-stop-sale td {
  background-color: inherit !important;
  /* 如需文字变红打开下面注释 */
   color: #f5222d; 
}
</style>